import _ from 'lodash';
import {
  Col,
  ColFilters,
  Filter,
  FilterValueMode,
  FilterValues,
  Sheet,
  SheetView,
} from '../../types';

export const getCurrentFilters = (
  // userId: string,
  sheet: Pick<Sheet, 'filters' | 'usersPreferences'>,
  sheetView: Pick<SheetView, 'isLocalFilter' | 'localFilters'>
) => {
  let filters = sheet.filters;
  // const prefs = sheet.usersPreferences[userId];

  if (sheetView.isLocalFilter) {
    filters = sheetView.localFilters ?? {};
  }
  // else if (prefs && prefs.filter && prefs.filter.useCustomFilter) {
  //   filters = prefs.filter.customFilters ?? {};
  // }

  return filters;
};

export const getColumnFilter = (
  colIndex: number,
  filters: ColFilters,
  cols: Col[]
): Filter | undefined => {
  const colId = cols[colIndex]?.id;

  if (filters && filters[colId]) {
    return _.cloneDeep(filters[colId]);
  }
};

export const isFilterValueChanged = (
  valueMode: FilterValueMode,
  filterValues: FilterValues
) => valueMode === FilterValueMode.Select || !!Object.keys(filterValues).length;
